module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBoldItalic.9750527.eot";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-SemiBoldItalic.eot
// module id = ydeH
// module chunks = 3